<!--  -->
<template>
  <div id="edit-priority">
    <div class="priority-menu">
      <zlr-menu :menuList="menuList"></zlr-menu>
    </div>
    <div class="priority-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
// components
import ZlrMenu from '@/components/menu-row/menu-row'
export default {
  name: 'timesheet-penalty',
  components: {
    ZlrMenu
  },
  data () {
    return {
      menuList: [
        {
          title: 'Timesheet',
          name: ['timesheet']
        },
        {
          title: 'Penalty',
          name: ['penalty']
        }
      ]
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
.priority {
  &-menu {
    padding-top: 24px;
    margin-top: 40px;
    background-color: #fff;
  }
}
</style>
